module.exports = __webpack_public_path__ + "static/media/loginButton.67f06f74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginButton.svg
// module id = 152
// module chunks = 0